import { Nav, Modal, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import PropsTypes from "prop-types";
import { useContext, useState } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import auth0 from "auth0-js";
import { datadogRum } from "@datadog/browser-rum";
import logo from "../../assets/images/playerview/logo.svg";
import profileicon from "../../assets/images/playerview/profile-icon.svg";
import settingicon from "../../assets/images/playerview/setting-icon.svg";
import refreshicon from "../../assets/images/playerview/refresh-icon.svg";
import socket from "../../config/socket";
import closeicon from "../../assets/images/playerview/close-icon.svg";
import logout from "../../assets/images/playerview/exit.svg";
import UserContext from "../../context/UserContext";
import BarRoomSetting from "../barRoom/settings";
import QrModal from "./qrmodal";
import { clientId, ddEnable, domain } from "../../config/keys";
import UsersIcon from "../../IconComponents/UsersIcon";
import { logOut } from "../../utils/Api";

const webAuth = new auth0.WebAuth({
  domain,
  clientID: clientId,
});
webAuth.popup.callback();
function Sidebar({ showSidebar, handleSidebar }) {
  const [show, setShow] = useState(false);
  const [showQR, setShowQR] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseQR = () => setShowQR(false);
  const handleShowQR = () => setShowQR(true);

  const [leave, setLeave] = useState(false);
  const handleLeaveClose = () => setLeave(false);
  const handleLeaveShow = () => setLeave(true);

  const navigate = useNavigate();
  const { gameId } = useParams();
  const { setTokens, setUser, user, responsiveScale } = useContext(UserContext);

  const handleLogout = async () => {
    const token = JSON.parse(localStorage.getItem("token"));
    const refreshToken = token.refresh.token;
    await logOut({ refreshToken });
    localStorage.clear();
    setTokens();
    setUser({});
    navigate("/login");
    if (ddEnable === "true") {
      datadogRum.clearUser();
      datadogRum.clearGlobalContext();
    }
  };

  const handleLeaveBarRoom = async () => {
    setLeave(false);
    socket.emit("leaveBarRoom", { gameid: gameId, userId: user.id });
    navigate("/user/?modal=profile");
  };

  //  Screen Scaling Function Start
  const { scaleValue } = responsiveScale;
  return (
    <div className={`player-game-sidebar ${showSidebar ? "" : "hide"}`}>
      <div className="player-game-sidebar-menu">
        <div
          className="player-sidebar-logo"
          onClick={handleSidebar}
          role="presentation"
        >
          <img src={logo} alt="" />
        </div>
        <Nav>
          <NavLink to="?modal=profile">
            <img src={profileicon} alt="" />
            <span>Profile</span>
          </NavLink>
          {user?.role === "admin" ? (
            <NavLink to="/user-management" title="User Management">
              <UsersIcon />
              <span>User Management</span>
            </NavLink>
          ) : (
            ""
          )}
          {/* <NavLink to="/">
            <img src={refreshicon} alt="" />
            <span>Refresh</span>
          </NavLink> */}
          {(user?.role === "dealer" || user?.role === "admin") && (
            <NavLink to="/dealer/request-access">
              <img src={refreshicon} alt="" />
              <span>Request Access List</span>
            </NavLink>
          )}
          {/* <NavLink to="/">
            <img src={imageicon} alt="" />
            <span>Gallery</span>
          </NavLink> */}
          <span onClick={handleShow} role="presentation">
            <img src={settingicon} alt="" />
            <span>Settings</span>
          </span>
          {user?.role !== "dealer" && (
            <span onClick={handleShowQR} role="presentation">
              <QrIcon fill={`${showQR ? "#ffffff" : "#A0AABB"}`} />
              <span>QR-code</span>
            </span>
          )}
          {user?.role !== "dealer" && gameId && (
            <span onClick={handleLeaveShow} role="presentation">
              <img src={logout} alt="" />
              <span>Leave</span>
            </span>
          )}
          <span onClick={handleLogout} role="presentation">
            <img src={logout} alt="" />
            <span>Logout</span>
          </span>
          <span onClick={handleSidebar} role="presentation">
            <img src={closeicon} alt="" />
          </span>
        </Nav>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="bar-room-setting-popup"
        style={{
          transform: `translate(-50%, 0%) scale(${scaleValue / 100})`,
        }}
      >
        {show && (
          <Helmet>
            <body className="bar-room-setting-page" />
          </Helmet>
        )}
        <BarRoomSetting />
      </Modal>
      <Modal
        show={leave}
        onHide={handleLeaveClose}
        centered
        className="bar-room-leave-popup"
      >
        {leave && (
          <Helmet>
            <body className="bar-room-setting-page" />
          </Helmet>
        )}
        <div className="bar-room-leave">
          <p>Are you sure you want to leave the bar room?</p>
          <div className="bar-room-leave-btn">
            <Button className="bg-btn" onClick={handleLeaveBarRoom}>
              Leave
            </Button>
            <Button className=" bg-btn outline-btn" onClick={handleLeaveClose}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        show={showQR}
        onHide={handleCloseQR}
        className="bar-room-setting-popup cpn-qr-popup"
        centered
        style={{
          transform: `translate(-50%, 0%) scale(${scaleValue / 100})`,
        }}
      >
        {/* <span
          onClick={handleCloseQR}
          className="close-model-icon"
          role="presentation"
        >
          <ClossIcon />
        </span> */}
        {showQR && (
          <Helmet>
            <body className="bar-room-setting-page" />
          </Helmet>
        )}
        <QrModal />
      </Modal>
    </div>
  );
}

export default Sidebar;

Sidebar.propTypes = {
  showSidebar: PropsTypes.bool.isRequired,
  handleSidebar: PropsTypes.func.isRequired,
};

function QrIcon({ fill }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 11C4.45 11 3.979 10.804 3.587 10.412C3.19567 10.0207 3 9.55 3 9V5C3 4.45 3.19567 3.979 3.587 3.587C3.979 3.19567 4.45 3 5 3H9C9.55 3 10.021 3.19567 10.413 3.587C10.8043 3.979 11 4.45 11 5V9C11 9.55 10.8043 10.0207 10.413 10.412C10.021 10.804 9.55 11 9 11H5ZM5 9H9V5H5V9ZM5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V15C3 14.45 3.19567 13.979 3.587 13.587C3.979 13.1957 4.45 13 5 13H9C9.55 13 10.021 13.1957 10.413 13.587C10.8043 13.979 11 14.45 11 15V19C11 19.55 10.8043 20.021 10.413 20.413C10.021 20.8043 9.55 21 9 21H5ZM5 19H9V15H5V19ZM15 11C14.45 11 13.9793 10.804 13.588 10.412C13.196 10.0207 13 9.55 13 9V5C13 4.45 13.196 3.979 13.588 3.587C13.9793 3.19567 14.45 3 15 3H19C19.55 3 20.021 3.19567 20.413 3.587C20.8043 3.979 21 4.45 21 5V9C21 9.55 20.8043 10.0207 20.413 10.412C20.021 10.804 19.55 11 19 11H15ZM15 9H19V5H15V9ZM19.5 21C19.3667 21 19.25 20.95 19.15 20.85C19.05 20.75 19 20.6333 19 20.5V19.5C19 19.3667 19.05 19.25 19.15 19.15C19.25 19.05 19.3667 19 19.5 19H20.5C20.6333 19 20.75 19.05 20.85 19.15C20.95 19.25 21 19.3667 21 19.5V20.5C21 20.6333 20.95 20.75 20.85 20.85C20.75 20.95 20.6333 21 20.5 21H19.5ZM13.5 15C13.3667 15 13.25 14.95 13.15 14.85C13.05 14.75 13 14.6333 13 14.5V13.5C13 13.3667 13.05 13.25 13.15 13.15C13.25 13.05 13.3667 13 13.5 13H14.5C14.6333 13 14.75 13.05 14.85 13.15C14.95 13.25 15 13.3667 15 13.5V14.5C15 14.6333 14.95 14.75 14.85 14.85C14.75 14.95 14.6333 15 14.5 15H13.5ZM15.5 17C15.3667 17 15.25 16.95 15.15 16.85C15.05 16.75 15 16.6333 15 16.5V15.5C15 15.3667 15.05 15.25 15.15 15.15C15.25 15.05 15.3667 15 15.5 15H16.5C16.6333 15 16.75 15.05 16.85 15.15C16.95 15.25 17 15.3667 17 15.5V16.5C17 16.6333 16.95 16.75 16.85 16.85C16.75 16.95 16.6333 17 16.5 17H15.5ZM13.5 19C13.3667 19 13.25 18.95 13.15 18.85C13.05 18.75 13 18.6333 13 18.5V17.5C13 17.3667 13.05 17.25 13.15 17.15C13.25 17.05 13.3667 17 13.5 17H14.5C14.6333 17 14.75 17.05 14.85 17.15C14.95 17.25 15 17.3667 15 17.5V18.5C15 18.6333 14.95 18.75 14.85 18.85C14.75 18.95 14.6333 19 14.5 19H13.5ZM15.5 21C15.3667 21 15.25 20.95 15.15 20.85C15.05 20.75 15 20.6333 15 20.5V19.5C15 19.3667 15.05 19.25 15.15 19.15C15.25 19.05 15.3667 19 15.5 19H16.5C16.6333 19 16.75 19.05 16.85 19.15C16.95 19.25 17 19.3667 17 19.5V20.5C17 20.6333 16.95 20.75 16.85 20.85C16.75 20.95 16.6333 21 16.5 21H15.5ZM17.5 19C17.3667 19 17.25 18.95 17.15 18.85C17.05 18.75 17 18.6333 17 18.5V17.5C17 17.3667 17.05 17.25 17.15 17.15C17.25 17.05 17.3667 17 17.5 17H18.5C18.6333 17 18.75 17.05 18.85 17.15C18.95 17.25 19 17.3667 19 17.5V18.5C19 18.6333 18.95 18.75 18.85 18.85C18.75 18.95 18.6333 19 18.5 19H17.5ZM17.5 15C17.3667 15 17.25 14.95 17.15 14.85C17.05 14.75 17 14.6333 17 14.5V13.5C17 13.3667 17.05 13.25 17.15 13.15C17.25 13.05 17.3667 13 17.5 13H18.5C18.6333 13 18.75 13.05 18.85 13.15C18.95 13.25 19 13.3667 19 13.5V14.5C19 14.6333 18.95 14.75 18.85 14.85C18.75 14.95 18.6333 15 18.5 15H17.5ZM19.5 17C19.3667 17 19.25 16.95 19.15 16.85C19.05 16.75 19 16.6333 19 16.5V15.5C19 15.3667 19.05 15.25 19.15 15.15C19.25 15.05 19.3667 15 19.5 15H20.5C20.6333 15 20.75 15.05 20.85 15.15C20.95 15.25 21 15.3667 21 15.5V16.5C21 16.6333 20.95 16.75 20.85 16.85C20.75 16.95 20.6333 17 20.5 17H19.5Z"
        fill={fill}
      />
    </svg>
  );
}

QrIcon.propTypes = {
  fill: PropsTypes.string.isRequired,
};
